export default __webpack_public_path__ + "static/Inter-SemiBold-45b4c2ae493bb481102f8c1e39dc1c8d.ttf";